import { Component } from "react";
import './TermsConditions.css'
import { GoLinkExternal } from "react-icons/go";

class TermsConditions extends Component {
    render() {
        return (
            <div className="bg-light">
                <div className="content-column">
                    <div className="sb-content-column-inner">
                        <div className="py-text">
                            <div className="text-xs">
                                <p className="pb2">At participating stores. Restrictions apply.</p>
                                <p className="p1">
                                    <sup>1</sup>
                                    Excludes taxes and gratuities.
                                    At participating stores. Some
                                    restrictions apply. Flights
                                    purchased close to departure
                                    may not earn double Stars. Stars
                                    and miles may not be earned on
                                    purchases of alcohol, Starbucks
                                    Cards and Starbucks Card reloads.
                                    For details, visit
                                    <a
                                        aria-label='deltastarbucks.com/terms, opens in new window'
                                        className='external-links'
                                        href='https://www.deltastarbucks.com/content/starbucks/en/terms-and-conditions.html'
                                        target='_blank'
                                        rel='noopener noreferrer'><span className='text-link'>deltastarbucks.com/terms</span>
                                        <svg className='icon-link'><GoLinkExternal /></svg>
                                    </a>.
                                </p>
                                <p className="p1">
                                    <sup>2</sup>
                                    At participating stores only.
                                    Some restrictions apply. Linked
                                    Card members will earn 2% Cash Back
                                    on the full purchase price of every
                                    Qualifying Purchase. Extra Star offer
                                    excludes taxes and tips. Stars may not
                                    be earned on purchases of alcohol or
                                    on reloads of Starbucks Cards that are
                                    not registered. For details, visit
                                    <a
                                        aria-label='deltastarbucks.com/terms, opens in new window'
                                        className='external-links'
                                        href='https://promotions.bankofamerica.com/starbucks#disclosure-1223753557'
                                        target='_blank'
                                        rel='noopener noreferrer'><span className='text-link'>Terms and Conditions</span>
                                        <svg className='icon-link'><GoLinkExternal /></svg>
                                    </a>. Bank of America, N.A. Member FDIC.
                                </p>
                                <p className="p1">
                                    <sup>3</sup>
                                    Individuals must link loyalty program
                                    accounts to participate in offer.
                                    Members with linked accounts will earn:
                                    (a) double Starbucks Rewards Stars on
                                    Qualifying Starbucks Transactions during
                                    Eligible Stays at Participating Marriott
                                    Bonvoy Hotels, excluding stays at Homes &
                                    Villas by Marriott Bonvoy and The Ritz-Carlton
                                    Yacht Collection, and (b) earn 100 Marriott Bonvoy
                                    Points upon completion of 3 Qualifying Starbucks
                                    Transactions during Marriott Bonvoy Week. Qualifying
                                    Starbucks Transactions must be made at U.S. participating
                                    Starbucks stores and exclude purchases of alcoholic beverages,
                                    Starbucks Card eGifts and physical Starbucks gift. To earn
                                    Double Stars, the applicable stay must qualify as an
                                    Eligible Stay at a Participating Marriott Bonvoy®
                                    Hotel under offer terms and conditions. Other restrictions
                                    and exclusions apply. For full offer terms and conditions, visit
                                    <a
                                        aria-label='Starbucks.com/MarriottBonvoy, opens in new window'
                                        className='external-links'
                                        href='https://www.starbucks.com/rewards/partnerships/marriottbonvoy#disclaimerTitleId'
                                        target='_blank'
                                        rel='noopener noreferrer'><span className='text-link'>Starbucks.com/MarriottBonvoy</span>
                                        <svg className='icon-link'><GoLinkExternal /></svg>
                                    </a>
                                    . Marriott Bonvoy® and its affiliated brands
                                    and hotels are the registered trademarks
                                    and/or service marks of Marriott International,
                                    Inc. and its affiliates. Used under license
                                    from Marriott International, Inc.
                                </p>
                            </div>
                            <div className="md-flex-text">
                                <div className="earning-stars">
                                    <div className="earning-stars-content">
                                        <h3 className="sb-heading-tc">Earning Stars</h3>
                                        <p className="es-content">
                                            Stars cannot be earned on purchases of alcohol,
                                            Starbucks Cards or Starbucks Card reloads.
                                        </p>
                                        <p className="es-content">
                                            Earn 1 Star per $1 spent when you scan
                                            your member barcode in the app, then
                                            pay with cash, credit/debit cards or
                                            mobile wallets at participating stores.
                                            You can also earn 1 Star per $1 spent
                                            when you link a payment method and pay
                                            directly through the app.
                                        </p>
                                        <p className="es-content">
                                            Earn 2 Stars per $1 spent when you
                                            load funds and pay with your digital
                                            Starbucks Card in the app. You can also
                                            earn 2 Stars per $1 spent when you pay
                                            in-person at a participating store with
                                            your registered physical Starbucks Card
                                            or scan your member barcode in the app,
                                            and then use any physical Starbucks
                                            Card (regardless of whether it is
                                            registered) to complete the purchase.
                                        </p>
                                    </div>
                                    <div>
                                        <h3 className="sb-heading-tc">Benefits</h3>
                                        <p className="es-content">Free refills
                                            available during same in-store
                                            visit only. To qualify for the
                                            Birthday Reward, you must have
                                            made at least one Star-earning
                                            transaction.
                                        </p>
                                    </div>
                                </div>
                                <div className="termsOfUse">
                                    <div className="termsOfUse-content">
                                        <h3 className="sb-heading-tc">Terms of Use</h3>
                                        <p className="es-content">For full program details visit <a
                                            aria-label='starbucks.com/rewards/terms, opens in new window'
                                            className='external-links'
                                            href='https://www.starbucks.com/rewards/terms/'
                                            target='_blank'
                                            rel='noopener noreferrer'><span className='text-link'>starbucks.com/rewards/terms</span>
                                            <svg className='icon-link'><GoLinkExternal /></svg>
                                        </a>
                                            .
                                        </p>
                                        <p className="es-content">Starbucks® Rewards
                                            benefits are available at participating
                                            Starbucks stores. Not all stores have the
                                            ability to honor Rewards at this time. Visit the <a
                                                aria-label='Starbucks Store Locator, opens in new window'
                                                className='external-links'
                                                href='https://www.starbucks.com/store-locator'
                                                target='_blank'
                                                rel='noopener noreferrer'><span className='text-link'>Starbucks Store Locator</span>
                                                <svg className='icon-link'><GoLinkExternal /></svg>
                                            </a>
                                            and search for locations honoring “Redeem Rewards”.
                                        </p>                                        
                                    </div>
                                    <div>
                                    <h3 className="sb-heading-tc">Redeeming Rewards</h3>
                                    <p className="es-content">
                                    Rewards cannot be redeemed for alcoholic 
                                    beverages or multi-serve items. You pay 
                                    the difference for any beverage customization 
                                    over $1 and/or merchandise item over $20. Not 
                                    all stores honor tiered Rewards. Select stores 
                                    redeem 200 Stars for free food or drink items 
                                    only.
                                    </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default TermsConditions